module.exports = __webpack_public_path__ + "img/br2.af33689.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br2.jpg
// module id = i9CR
// module chunks = 0